export default __webpack_public_path__ + "static/modular-one-storage-console-19a627133b591e4296cda3a87e72032f.png";